import { useQuery } from 'hooks/useCustomQuery';
import getCompanyServicesWithSRT from 'API/SRT/getCompanyServicesWithSRT';
import getSRTService from 'API/SRT/getSRTService';

/**
 * The company's SRT service, for the regions and channel ceiling its trunks
 * are constrained by.
 *
 * @param {object}   params
 * @param {string}   params.companyID
 * @param {function} params.onSuccess Receives `{ regions, maxChannel }`.
 */
const useGetSRTTrunkService = ({ companyID, onSuccess }) => {
    return useQuery({
        queryKey: ['srtTrunkService', companyID],
        queryFn: async () => {
            const res = await getCompanyServicesWithSRT(companyID);
            const srtService = res.data.find((s) => s.serviceType === 'SRT');
            if (!srtService?.id) return { regions: [], maxChannel: 0 };
            const svcRes = await getSRTService(srtService.id);
            return {
                regions: svcRes.data.regions || [],
                maxChannel: svcRes.data.maxChannel || 0,
            };
        },
        enabled: Boolean(companyID),
        onSuccess,
    });
};

export default useGetSRTTrunkService;
